import store from "@/general/store";
import {
  Module,
  VuexModule,
  getModule,
  MutationAction
} from "vuex-module-decorators";
import { ListResponse, GrantCriteria } from "@/general/store/models";
import { getGrantCriteriaList } from "../api";

@Module({
  name: "grantCriterialist",
  namespaced: true,
  store: store,
  dynamic: true
})
class GrantCriteriaListModule extends VuexModule {
  GrantCriteriaListResponse: ListResponse<GrantCriteria> | null = null;

  @MutationAction
  async getGrantCriteriaList() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = urlParams.get("page");
    const pageSizeParam = urlParams.get("page_size");
    const orderingParam = urlParams.get("ordering");
    const searchParam = urlParams.get("search");

    const currentPage = pageParam ? parseInt(pageParam) : 1;
    const pageSize = pageSizeParam ? parseInt(pageSizeParam) : 20;
    const ordering = orderingParam ? orderingParam : "";
    const search = searchParam ? searchParam : "";

    const GrantCriteriaListResponse: ListResponse<GrantCriteria> = await getGrantCriteriaList(
      ordering,
      currentPage,
      pageSize,
      search
    );
    return { GrantCriteriaListResponse };
  }
}

export default getModule(GrantCriteriaListModule);
